export const AUTH_TYPES = {
  SET_USER_DATA: 'SET_USER_DATA',
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  REGISTER_USER_SUPPLIER: 'REGISTER_USER_SUPPLIER',
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  SET_VERIFICATION_STATUS: 'SET_VERIFICATION_STATUS',
  SET_USER_COMMENTS: 'SET_USER_COMMENTS',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_REFRESH_TOKEN: 'SET_REFRESH_TOKEN',
  SET_MACHINE_INFO: 'SET_MACHINE_INFO',
  SET_PLANT_INFO: 'SET_PLANT_INFO',
};

// Action to set user data
export const setUserDataAction = (userData) => {
  return function (dispatch) {
    // Extract fields related to auth
    const { token, isVerified, ...userDataWithoutAuth } = userData;

    // Dispatch action to update user data
    dispatch({
      type: AUTH_TYPES.SET_USER_DATA,
      payload: userDataWithoutAuth,
    });

    // If an auth token is present, update the token
    if (token) {
      dispatch(setAuthTokenAction(token));
    }

    // If verification status is provided, update it
    if (isVerified !== undefined) {
      dispatch({
        type: AUTH_TYPES.SET_VERIFICATION_STATUS,
        payload: isVerified,
      });
    }
  };
};

export const setUserProfile = (profileData) => {
  return function (dispatch) {
    dispatch({
      type: AUTH_TYPES.SET_USER_PROFILE,
      payload: profileData,
    });
  };
};

// Action to set auth token
export const setAuthTokenAction = (token) => {
  return function (dispatch) {
    // Save token to localStorage
    localStorage.setItem('accessToken', token);

    dispatch({
      type: AUTH_TYPES.SET_AUTH_TOKEN,
      payload: token,
    });
  };
};

export const setRefreshTokenAction = (token) => {
  return function (dispatch) {
    // Save token to localStorage
    localStorage.setItem('refreshToken', token);

    dispatch({
      type: AUTH_TYPES.SET_REFRESH_TOKEN,
      payload: token,
    });
  };
};

// Action to register a new supplier user
export const registerSupplierAction = (registrationData) => {
  return function (dispatch) {
    const safeRegistrationData = {
      ...registrationData,
      service_offered: registrationData.service_offered || [],
      software_used: registrationData.software_used || [],
      professional_associations:
        registrationData.professional_associations || [],
      who_are_your_major_customers:
        registrationData.who_are_your_major_customers || [],
    };

    dispatch({
      type: AUTH_TYPES.REGISTER_USER_SUPPLIER,
      payload: safeRegistrationData,
    });
  };
};

// Action to log in a user
export const loginUserAction = (userData) => {
  return function (dispatch) {
    dispatch({
      type: AUTH_TYPES.LOGIN_USER,
      payload: userData,
    });
  };
};

// Action to log out the user
export const logoutUserAction = () => {
  return function (dispatch) {
    // Clear localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('authState');
    localStorage.removeItem('authKeyExpiredAt');
    localStorage.removeItem('loglevel');
    localStorage.removeItem('authState');
    localStorage.removeItem('projectState');
    localStorage.removeItem('searchState');
    localStorage.removeItem('dumpState');
    // Dispatch the logout action
    dispatch({
      type: AUTH_TYPES.LOGOUT_USER,
    });
  };
};

// Action to set user verification status
export const setVerificationStatusAction = (status) => {
  return function (dispatch) {
    dispatch({
      type: AUTH_TYPES.SET_VERIFICATION_STATUS,
      payload: status,
    });
  };
};

// Action to update user role
export const setUserRoleAction = (role) => {
  return function (dispatch, getState) {
    const { userData } = getState().authReducer;

    // Update user role
    dispatch({
      type: AUTH_TYPES.SET_USER_DATA,
      payload: {
        ...userData,
        role,
      },
    });
  };
};

/*
// PROBLEM: This action will append the new plant-info/machining-info to the existing plant-info/machining-info array by doing [...currentPlantInfo, plantInfo]/ [...currentMachineInfo, machineInfo]. This is not the desired behavior. We need to update the existing plant-info/machining-info object in the array if it already exists. If it doesn't exist, then we can append it to the array.

export const setPlantInfoAction = (plantInfo) => {
  return function (dispatch, getState) {
    const currentPlantInfo =
      getState().authReducer.registrationData.plant_info || [];
    dispatch({
      type: AUTH_TYPES.SET_PLANT_INFO,
      payload: [...currentPlantInfo, plantInfo], // Append to the array
    });
  };
};
export const setMachineInfoAction = (machineInfo) => {
  return function (dispatch, getState) {
    const currentMachineInfo =
      getState().authReducer.registrationData.machining_info || [];
    dispatch({
      type: AUTH_TYPES.SET_MACHINE_INFO,
      payload: [...currentMachineInfo, machineInfo], // Append to the array
    });
  };
};
 */

export const setPlantInfoAction = (plantInfo, isEdit = false) => {
  return function (dispatch, getState) {
    const currentPlantInfo =
      getState().authReducer.registrationData.plant_info || [];

    // If it's an edit operation (determined by the flag)
    if (isEdit) {
      const updatedPlantInfo = currentPlantInfo.map((plant) =>
        plant.plant_id === plantInfo.plant_id ? plantInfo : plant,
      );

      dispatch({
        type: AUTH_TYPES.SET_PLANT_INFO,
        payload: updatedPlantInfo,
      });
    } else {
      // It's a new plant, append to array
      dispatch({
        type: AUTH_TYPES.SET_PLANT_INFO,
        payload: [...currentPlantInfo, plantInfo],
      });
    }
  };
};

export const setMachineInfoAction = (machineInfo, isEdit = false) => {
  return function (dispatch, getState) {
    const currentMachineInfo =
      getState().authReducer.registrationData.machining_info || [];

    // If it's an edit operation (determined by the flag)
    if (isEdit) {
      const updatedMachineInfo = currentMachineInfo.map((machine) =>
        machine.machine_id === machineInfo.machine_id ? machineInfo : machine,
      );

      dispatch({
        type: AUTH_TYPES.SET_MACHINE_INFO,
        payload: updatedMachineInfo,
      });
    } else {
      // It's a new machine, append to array
      dispatch({
        type: AUTH_TYPES.SET_MACHINE_INFO,
        payload: [...currentMachineInfo, machineInfo],
      });
    }
  };
};

// Action to set user comments
export const setUserCommentsAction = (comments) => {
  return function (dispatch) {
    dispatch({
      type: AUTH_TYPES.SET_USER_COMMENTS,
      payload: comments,
    });
  };
};
